import { getClinicalNotes, getPrescription, getConsultationById, shareConsultation, getPatientInfo, getPrescriptionPdf, getClinicalNotesPdf } from "../../../Common/axios_instance/video_https/video.https";

export const fetchConsultationDetail = (id: string) => getConsultationById(id);

export const fetchConsultationNotes = (id: string) => getClinicalNotes(id).catch(() => null);

export const fetchConsultationPrescription = (id: string) => getPrescription(id).catch(() => null);

export const fetchPatientInfo = (id: string) => getPatientInfo(id).catch(() => null);

export const fetchPrescriptionPdf = (id: string) => getPrescriptionPdf(id);

export const fetchClinicalNotesFileUrl = (id: string) => getClinicalNotesPdf(id);

export const shareConsultationData = (id: string, channels: string[]) =>
  shareConsultation(id, channels);
